import { z } from 'zod'

/***************** 학교급 *****************/
export const SCHOOL_TYPE = ['ELEMENTARY', 'MIDDLE', 'HIGH'] as const

/***************** 학년 *****************/
export const GRADE = [1, 2, 3, 4, 5, 6] as const

// 고등학교는 학년이 없고 과목만 있다. 다른 학교급의 학년 자리에 과목이 온다.
export const HIGH_SCHOOL_SUBJECT = [
  '고등수학(상)',
  '고등수학(하)',
  '수학 I',
  '수학 II',
  '미적분',
  '기하',
  '공통수학1',
  '공통수학2',
  '대수',
  '미적분1',
  '확률과 통계',
  '미적분2',
  '(구) 교육과정',
  '교육과정 외',
] as const

/***************** 학기 *****************/
// 고등학교는 학기가 없다. 학년·학기를 강제로 정해야 하는 예외는 Curriculum 쪽 상수가 다룬다.
export const SEMESTER = [1, 2] as const

/***************** 개정 *****************/
// 09 개정은 새로 만들지 않지만 옛 학습지·교재가 여전히 이 값으로 온다.
export const REVISION = ['CURRICULUM_09', 'CURRICULUM_15', 'CURRICULUM_22'] as const

/***************** 학교급 *****************/
export const SchoolTypeSchema = z.enum(SCHOOL_TYPE)
export type SchoolType = z.infer<typeof SchoolTypeSchema>

/***************** 학년 *****************/
export const GradeSchema = z.literal(GRADE)
export type NumberGradeElementary = z.infer<typeof GradeSchema>
export type NumberGradeMiddle = Extract<NumberGradeElementary, 1 | 2 | 3>
export type GradeElementary = `${NumberGradeElementary}`
export type GradeMiddle = `${NumberGradeMiddle}`
export type GradeElementaryMiddle = GradeElementary | GradeMiddle

export const HighSchoolSubjectSchema = z.enum(HIGH_SCHOOL_SUBJECT)
export type GradeHigh = z.infer<typeof HighSchoolSubjectSchema>

// 전체 학년(초·중·고). 고등은 과목이라 초·중 학년도 문자열로 통일한다.
export const AllGradeSubjectSchema = z.union([
  z.enum(GRADE.map(String) as [`${NumberGradeElementary}`, ...`${NumberGradeElementary}`[]]),
  HighSchoolSubjectSchema,
])
export type AllGradeSubject = z.infer<typeof AllGradeSubjectSchema>

/***************** 학기 *****************/
export const SemesterSchema = z.literal(SEMESTER).nullable()
export type Semester = z.infer<typeof SemesterSchema>

/***************** 개정 *****************/
export const RevisionSchema = z.enum(REVISION)
export type Revision = z.infer<typeof RevisionSchema>
